import { useQuery } from "@tanstack/react-query";
import { closeContract } from "@common/contracts/close.contract";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { closeQueryKeys } from "@api/close.api";

const closeClient = getBackendAPIClient(closeContract);

const closeUnreadTasksQueryKeys = {
    unreadTasks: (organizationId: string, closeId: string) =>
        [
            ...closeQueryKeys.detail(organizationId, closeId),
            "unread-tasks",
        ] as const,
};

/** Tasks in the work item where the current user has unread chat messages. */
export function useCloseUnreadTasksQuery(closeId: string) {
    const { organizationId } = useScope();

    return useQuery({
        queryKey: closeUnreadTasksQueryKeys.unreadTasks(
            organizationId ?? "",
            closeId,
        ),
        queryFn: async () => {
            const response = await closeClient.listCloseUnreadTasks({
                params: { organizationId: organizationId ?? "", closeId },
            });
            if (response.status !== 200) {
                throw new Error("Failed to load notifications");
            }
            return response.body.tasks;
        },
        enabled: !!organizationId,
    });
}
